const handleScrollFunc = () => {

    let invalidInputEncountered = false;

    document.querySelectorAll('input, select, textarea').forEach(input => {
        input.addEventListener('invalid', (event) => {
            if (!invalidInputEncountered) {
                document.getElementById('button__submit').classList.remove('spinner-active');

                input.scrollIntoView({ behavior: 'instant', block: 'center' });
                invalidInputEncountered = true;
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    document.getElementById('button__submit').addEventListener('click', () => {
        handleScrollFunc();
    });

    handleScrollFunc();
});